import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import { Helmet } from 'react-helmet';
import "./ContactUs.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ContactUs from "../../Common/ContactUs";
//import {Link} from "react-router-dom";
import {contact} from "../../data";

//import {Link} from "react-router-dom";

function App() {
  return <X10ContactUsPageDesktop {...x10ContactUsPageDesktopData} />;
}

export default App;

function X10ContactUsPageDesktop(props) {
  const {
    contactUs,
    rectangle85,
    rectangle99,
    sendAMessage,
    text72,
    //group89Props,
    textInputsNormal5Props,
    textInputsNormal6Props,
    textInputsNormal62Props,
    textInputsNormal63Props,
    button2Props,
    //footer3Props,
    //headerWithBackground2Props,
  } = props;

  return (
    <div className="cpd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | Contact Us</title>
        <meta name="keywords" content="Contact us, construction contact us page, contact us form. contact us page" />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="cpd-x10-contact-us-page-desktop">
        <div className="cpd-overlap-group">
          {/* <Group89
            line4={group89Props.line4}
            line5={group89Props.line5}
            line6={group89Props.line6}
            line7={group89Props.line7}
            line8={group89Props.line8}
          /> */}
          <div className="cpd-frame-1571">
            <h1 className="cpd-title cpd-valign-text-middle cpd-typographyheadlineh2-extrabold-40">{contactUs}</h1>
            
            {/* <img className="cpd-rectangle-85" src={rectangle85} /> */}
            <img className="cpd-rectangle-85" src={contact.ContactHeader} alt="Webuildd Contact Us" />
            <div className="cpd-flex-row">
              <iframe className="cpd-rectangle-99" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4758.027961564364!2d77.56739558617797!3d13.028810897148835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1785808f1037%3A0x3e8b84d6688c5383!2sWebuildd!5e0!3m2!1sen!2sin!4v1632809494580!5m2!1sen!2sin"></iframe>
              <div className="cpd-group-206">
                <div className="cpd-send-a-message cpd-valign-text-middle cpd-typographyheadlineh2-extrabold-40">
                  {sendAMessage}
                </div>
                <p className="cpd-text-28 cpd-typographybody16-regular">{text72}</p>
                <div className="cpd-frame-205">
                  <ContactUs />
                  {/* <TextInputsNormal52>{textInputsNormal5Props.children}</TextInputsNormal52>
                  <div className="cpd-frame-1651">
                    <TextInputsNormal62>{textInputsNormal6Props.children}</TextInputsNormal62>
                    <TextInputsNormal62 className={textInputsNormal62Props.className}>
                      {textInputsNormal62Props.children}
                    </TextInputsNormal62>
                  </div>
                  <TextInputsNormal62 className={textInputsNormal63Props.className}>
                    {textInputsNormal63Props.children}
                  </TextInputsNormal62> */}
                  {/*<Link to="/">
                    <Button23>{button2Props.children}</Button23>
                  </Link> */}
                </div>
              </div>
            </div>
            {/* <Footer32
              group32Props={footer3Props.group32Props}
              frame5Props={footer3Props.frame5Props}
              frame6Props={footer3Props.frame6Props}
              frame7Props={footer3Props.frame7Props}
            /> */}
            <Footer />
          </div>
          {/* <HeaderWithBackground23 {...headerWithBackground2Props} /> */}
          <NavBar />
        </div>
      </div>
    </div>
  );
}


function Group89(props) {
  const { line4, line5, line6, line7, line8 } = props;

  return (
    <div className="cpd-group-90">
      {/* <img className="cpd-line-4" src={line4} />
      <img className="cpd-line" src={line5} />
      <img className="cpd-line" src={line6} />
      <img className="cpd-line" src={line7} />
      <img className="cpd-line-8" src={line8} /> */}
    </div>
  );
}


function TextInputsNormal52(props) {
  const { children } = props;

  return (
    <div className="cpd-text-inputs-normal">
      <div className="cpd-frame-1 cpd-border-1px-light-grey">
        <div className="cpd-text-i26012812671 cpd-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function TextInputsNormal62(props) {
  const { children, className } = props;

  return (
    <div className={`cpd-text-inputs-normal-1 ${className || ""}`}>
      <div className="cpd-frame-1-1 cpd-border-1px-light-grey">
        <div className="cpd-text-i26012810671 cpd-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function Button23(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26012817TimelineData);
  }, []);

  return (
    <div className="cpd-x26012817 cpd-component cpd-component-wrapper not-ready">
      <div className="cpd-master-button-24ulab">
        <div className="cpd-button-i2601281751-SgFFGf cpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x26012817TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".cpd-x26012817",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer32(props) {
//   const { group32Props, frame5Props, frame6Props, frame7Props } = props;

//   return (
//     <div className="cpd-footer">
//       <div className="cpd-frame-1585">
//         <Frame1578
//           overlapGroup1={group32Props.overlapGroup1}
//           vector2={group32Props.vector2}
//           group86222Props={group32Props.group86222Props}
//           facebookAppSymbol3Props={group32Props.facebookAppSymbol3Props}
//           twitter3Props={group32Props.twitter3Props}
//         />
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Frame1578(props) {
  const { overlapGroup1, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

  return (
    <div className="cpd-frame-1578">
      <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
      <div className="cpd-frame-1584">
        <Group324 />
        <div className="cpd-frame-1583">
          <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
          <div className="cpd-instagram">
            <div className="cpd-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img
                className="cpd-vector"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg"
              />
              <img className="cpd-vector-1" src={vector2} />
            </div>
          </div>
          <Twitter3 src={twitter3Props.src} />
        </div>
      </div>
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="cpd-group-86">
      <White src={whiteProps.src} />
      <img className="cpd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="cpd-white">
      <img className="cpd-vector-2" src={src} />
    </div>
  );
}


function Group324() {
  return (
    <div className="cpd-group-32">
      <div className="cpd-group-189">
        <div className="cpd-map-pin-1">
          <div className="cpd-overlap-group1-1">
            <img
              className="cpd-vector-3"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-90@2x.svg"
            />
          </div>
        </div>
        <p className="cpd-text-1 cpd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="cpd-group-18">
        <div className="cpd-phone">
          <img
            className="cpd-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"
          />
        </div>
        <div className="cpd-text cpd-valign-text-middle cpd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="cpd-group-18">
        <div className="cpd-mail">
          <div className="cpd-overlap-group1-2">
            <img
              className="cpd-vector-5"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-93@2x.svg"
            />
          </div>
        </div>
        <div className="cpd-text cpd-valign-text-middle cpd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="cpd-facebook-app-symbol">
      <img className="cpd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="cpd-twitter">
      <img className="cpd-vector-6" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="cpd-frame-5">
      <div className="cpd-text-4 cpd-valign-text-middle cpd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="cpd-frame-4">
      <div className="cpd-text-2 cpd-valign-text-middle cpd-typographybody16-regular">{text41}</div>
      <div className="cpd-text-3 cpd-valign-text-middle cpd-typographybody16-regular">{text42}</div>
      <div className="cpd-text-3 cpd-valign-text-middle cpd-typographybody16-regular">{text43}</div>
      <div className="cpd-text-3 cpd-valign-text-middle cpd-typographybody16-regular">{text44}</div>
      <div className="cpd-text-3 cpd-valign-text-middle cpd-typographybody16-regular">{text45}</div>
      <div className="cpd-text-3 cpd-valign-text-middle cpd-typographybody16-regular">{text46}</div>
      <div className="cpd-text-3 cpd-valign-text-middle cpd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="cpd-frame-6">
      <div className="cpd-text-12 cpd-valign-text-middle cpd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="cpd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`cpd-frame-4-1 ${className || ""}`}>
      <div className="cpd-text-13 cpd-valign-text-middle cpd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="cpd-frame-1580">
        <div className="cpd-text-1-1 cpd-valign-text-middle cpd-typographybody16-regular">{text50}</div>
        <div className="cpd-place cpd-valign-text-middle cpd-typographybody16-regular">{place}</div>
        <div className="cpd-text-15 cpd-valign-text-middle cpd-typographybody16-regular">{text51}</div>
        <div className="cpd-text-16 cpd-valign-text-middle cpd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="cpd-frame-7">
      <div className="cpd-text-20 cpd-valign-text-middle cpd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


// function HeaderWithBackground23(props) {
//   const {
//     unselectedI2601281,
//     unselectedI26012812,
//     unselectedI26012813,
//     unselectedI26012814,
//     unselectedI26012815,
//     unselectedI26012816,
//     unselectedI26012817,
//     selectedI26012819,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="cpd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="cpd-frame-34">
//         <div className="cpd-frame-27">
//           <Link to="/">
//           <div className="cpd-unselected-i2601281 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI2601281}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="cpd-unselected-i2601281-1 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI26012812}
//           </div>
//           </Link>
//           <Link to="/project">
//           <div className="cpd-unselected-i2601281-2 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI26012813}
//           </div>
//           </Link>
//           <Link to="/video">
//           <div className="cpd-unselected-i2601281-3 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI26012814}
//           </div>
//           </Link>
//           <Link to="/insight">
//           <div className="cpd-unselected-i2601281-4 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI26012815}
//           </div>
//           </Link>
//           <Link to="/blog">
//           <div className="cpd-unselected-i2601281-5 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI26012816}
//           </div>
//           </Link>
//           <Link to="/faq">
//           <div className="cpd-unselected-i2601281-6 cpd-valign-text-middle cpd-typography-body-smalltext-14-regular">
//             {unselectedI26012817}
//           </div>
//           </Link>
//           <div className="cpd-group-119">
//             <div className="cpd-overlap-group1-3">
//               <div className="cpd-rectangle-61"></div>
//               <div className="cpd-selected-i26012819 cpd-valign-text-middle">{selectedI26012819}</div>
//             </div>
//           </div>
//         </div>
//         <GetAQuoteButton222>{getAQuoteButton22Props.children}</GetAQuoteButton222>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="cpd-group-86-1">
      <White src={whiteProps.src} />
      <img className="cpd-group-85-1" src={group85} />
    </div>
  );
}


function GetAQuoteButton222(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601281964120TimelineData);
  }, []);

  return (
    <div className="cpd-i26012819-64120 cpd-component cpd-component-wrapper not-ready">
      <div className="cpd-master-button-48ZiPc">
        <div className="cpd-button-i2601281964-OIcoLs cpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2601281964120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".cpd-i26012819-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];

const group89Data = {
    line4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-4@1x.svg",
    line5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-4@1x.svg",
    line6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-4@1x.svg",
    line7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-4@1x.svg",
    line8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-4@1x.svg",
};

const textInputsNormal52Data = {
    children: "Comment",
};

const textInputsNormal62Data = {
    children: "Name (Required)",
};

const textInputsNormal622Data = {
    children: "Email (Required)",
    className: "cpd-text-inputs-normal-2",
};

const textInputsNormal623Data = {
    children: "Phone Number  (Required)",
    className: "cpd-text-inputs-normal-3",
};

const button23Data = {
    children: "SEND MESSAGE",
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: whiteData,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-97@2x.svg",
};

const frame1578Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
    group86222Props: group86222Data,
    facebookAppSymbol3Props: facebookAppSymbol3Data,
    twitter3Props: twitter3Data,
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "cpd-interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "cpd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     group32Props: frame1578Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: white2Data,
};

const getAQuoteButton222Data = {
    children: "GET A QUOTE",
};

// const headerWithBackground23Data = {
//     unselectedI2601281: "HOME",
//     unselectedI26012812: "ABOUT US",
//     unselectedI26012813: "PROJECTS",
//     unselectedI26012814: "VIDEOS",
//     unselectedI26012815: "INSIGHTS",
//     unselectedI26012816: "BLOGS",
//     unselectedI26012817: "FAQ’S",
//     selectedI26012819: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton222Data,
// };

const x10ContactUsPageDesktopData = {
    contactUs: "Contact Us",
    rectangle85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/rectangle-85-3@2x.jpg",
    rectangle99: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-99@1x.png",
    sendAMessage: "Send a message",
    text72: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.",
    group89Props: group89Data,
    textInputsNormal5Props: textInputsNormal52Data,
    textInputsNormal6Props: textInputsNormal62Data,
    textInputsNormal62Props: textInputsNormal622Data,
    textInputsNormal63Props: textInputsNormal623Data,
    button2Props: button23Data,
    //footer3Props: footer32Data,
    //headerWithBackground2Props: headerWithBackground23Data,
};

